import { TipoLojaProps } from 'components/autocompletes/TipoLojaAutoComplete';

export type BiTipoPainel = {
    idTipoPainelBi: number;
    dsTipoPainelBi: string;
    tipoPainelBiEnum: string;
};

export type BiGrupoUsuario = {
    idGrupoUsuario: number;
    dsGrupoUsuario: string;
};

export type ConfigBi = {
    idConfigBi?: number;
    dsConfigBi: string;
    cdPainelBi: string;
    dsUrl: string;
    dsUrlMobile: string;
    fgAtivo: boolean;
    vlAltura: number;
    vlAlturaMobile: number | null;
    nrSequencia: number | null;
    tipoPainelBi: BiTipoPainel | null;
    tipoLoja: TipoLojaProps[];
    grupoUsuario: BiGrupoUsuario[];
};

export const initialValues: ConfigBi = {
    dsConfigBi: '',
    cdPainelBi: '',
    dsUrl: '',
    dsUrlMobile: '',
    vlAltura: 0,
    vlAlturaMobile: null,
    fgAtivo: true,
    nrSequencia: null,
    tipoPainelBi: null,
    tipoLoja: [],
    grupoUsuario: [],
};
